/**
 * Retire les accents d'une chaîne.
 *
 * Utile au seul skin pixel : `Press Start 2P` n'a pas de véritables accents
 * lisibles à 10–12 px, et ce skin écrit toute sa chrome en capitales. Les
 * paragraphes, eux, sont en `Silkscreen` et gardent leurs accents — on ne
 * désaccentue jamais un texte de contenu.
 *
 * La décomposition NFD sépare la lettre de son accent ; il ne reste qu'à jeter
 * les marques combinantes (U+0300 à U+036F).
 */
export function deaccent(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '');
}

/** Majuscules sans accents : l'écriture attendue par la chrome 8 bits. */
export function arcadeCase(value: string): string {
  return deaccent(value).toUpperCase();
}
